module.exports = __webpack_public_path__ + "static/img/schengen-1.ad32a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/schengen-1.jpg
// module id = QwLt
// module chunks = 4